(function () {
  var galleries = document.querySelectorAll('[data-product-gallery]');
  if (!galleries.length) return;

  var LUMINANCE_THRESHOLD = 140;
  var SAMPLE_SIZE = 24;
  var COUNTER_REGION = { left: 0.15, top: 0.78, right: 0.85, bottom: 0.98 };
  var contrastCache = {};
  var sharedCanvas;
  var sharedContext;

  function sampleContext() {
    if (sharedContext) return sharedContext;
    sharedCanvas = document.createElement('canvas');
    sharedCanvas.width = SAMPLE_SIZE;
    sharedCanvas.height = SAMPLE_SIZE;
    sharedContext = sharedCanvas.getContext('2d', { willReadFrequently: true });
    return sharedContext;
  }

  function samplingUrl(src) {
    if (!src) return null;
    if (src.indexOf('cdn.shopify.com') === -1 && src.indexOf('shopify.com/s/files') === -1) {
      return src;
    }

    try {
      var url = new URL(src, window.location.href);
      url.searchParams.set('width', '96');
      url.searchParams.delete('height');
      return url.toString();
    } catch (error) {
      return src;
    }
  }

  function coverSourceRect(img, viewW, viewH) {
    var iW = img.naturalWidth;
    var iH = img.naturalHeight;
    if (!iW || !iH || !viewW || !viewH) {
      return { sx: 0, sy: 0, sw: iW || 0, sh: iH || 0 };
    }

    var imageRatio = iW / iH;
    var viewRatio = viewW / viewH;

    if (imageRatio > viewRatio) {
      var sw = iH * viewRatio;
      return { sx: (iW - sw) / 2, sy: 0, sw: sw, sh: iH };
    }

    var sh = iW / viewRatio;
    return { sx: 0, sy: (iH - sh) / 2, sw: iW, sh: sh };
  }

  function measureLuminanceFromImage(sourceImg, sourceRect) {
    var context = sampleContext();
    if (!context || !sourceImg || !sourceImg.naturalWidth) return null;

    try {
      context.clearRect(0, 0, SAMPLE_SIZE, SAMPLE_SIZE);

      if (sourceRect) {
        context.drawImage(
          sourceImg,
          sourceRect.sx,
          sourceRect.sy,
          sourceRect.sw,
          sourceRect.sh,
          0,
          0,
          SAMPLE_SIZE,
          SAMPLE_SIZE
        );
      } else {
        context.drawImage(sourceImg, 0, 0, SAMPLE_SIZE, SAMPLE_SIZE);
      }

      var pixels = context.getImageData(0, 0, SAMPLE_SIZE, SAMPLE_SIZE).data;
      var x0 = Math.max(0, Math.floor(COUNTER_REGION.left * SAMPLE_SIZE));
      var y0 = Math.max(0, Math.floor(COUNTER_REGION.top * SAMPLE_SIZE));
      var x1 = Math.min(SAMPLE_SIZE, Math.ceil(COUNTER_REGION.right * SAMPLE_SIZE));
      var y1 = Math.min(SAMPLE_SIZE, Math.ceil(COUNTER_REGION.bottom * SAMPLE_SIZE));

      if (x1 <= x0) x1 = Math.min(SAMPLE_SIZE, x0 + 1);
      if (y1 <= y0) y1 = Math.min(SAMPLE_SIZE, y0 + 1);

      var sum = 0;
      var count = 0;

      for (var y = y0; y < y1; y += 1) {
        for (var x = x0; x < x1; x += 1) {
          var p = (y * SAMPLE_SIZE + x) * 4;
          sum +=
            0.2126 * pixels[p] +
            0.7152 * pixels[p + 1] +
            0.0722 * pixels[p + 2];
          count += 1;
        }
      }

      if (!count) return null;
      return sum / count < LUMINANCE_THRESHOLD;
    } catch (error) {
      return null;
    }
  }

  function analyzeCounterContrast(gallery, slide, counter, pendingToken) {
    if (!slide || !counter) return;

    var img = slide.querySelector('img');
    if (!img) return;

    function paint(onDark) {
      if (pendingToken.cancelled) return;

      if (onDark === null) {
        counter.classList.remove(
          'product-gallery__counter--on-dark',
          'product-gallery__counter--on-light'
        );
        return;
      }

      counter.classList.toggle('product-gallery__counter--on-dark', onDark);
      counter.classList.toggle('product-gallery__counter--on-light', !onDark);
    }

    function viewportSize() {
      if (!gallery || !gallery.hasAttribute('data-gallery-fixed-frame')) {
        return null;
      }

      var viewport = gallery.querySelector('.product-gallery__viewport');
      if (!viewport) return null;

      var rect = viewport.getBoundingClientRect();
      if (!rect.width || !rect.height) return null;
      return { width: rect.width, height: rect.height };
    }

    function sourceRectFor(sourceImg) {
      var view = viewportSize();
      if (!view) return null;
      return coverSourceRect(sourceImg, view.width, view.height);
    }

    function cacheKeyFor(source) {
      var view = viewportSize();
      var viewKey = view ? Math.round(view.width) + 'x' + Math.round(view.height) : 'natural';
      return source + ':' + viewKey;
    }

    function runAnalysis() {
      if (pendingToken.cancelled) return;

      var src = img.currentSrc || img.getAttribute('src');
      var url = samplingUrl(src);
      if (!url) {
        paint(null);
        return;
      }

      var cacheKey = cacheKeyFor(url);
      if (Object.prototype.hasOwnProperty.call(contrastCache, cacheKey)) {
        paint(contrastCache[cacheKey]);
        return;
      }

      var sample = new Image();
      sample.decoding = 'async';
      sample.crossOrigin = 'anonymous';
      sample.onload = function () {
        if (pendingToken.cancelled) return;
        var onDark = measureLuminanceFromImage(sample, sourceRectFor(sample));
        if (onDark !== null) contrastCache[cacheKey] = onDark;
        paint(onDark);
      };
      sample.onerror = function () {
        paint(null);
      };
      sample.src = url;
    }

    runAnalysis();
  }

  function slideDimensions(slide) {
    var img = slide.querySelector('img');
    if (img && img.naturalWidth && img.naturalHeight) {
      return { width: img.naturalWidth, height: img.naturalHeight };
    }

    var width = parseInt(slide.getAttribute('data-width'), 10);
    var height = parseInt(slide.getAttribute('data-height'), 10);
    if (width && height) {
      return { width: width, height: height };
    }

    if (img) {
      width = parseInt(img.getAttribute('width'), 10);
      height = parseInt(img.getAttribute('height'), 10);
      if (width && height) {
        return { width: width, height: height };
      }
    }

    return null;
  }

  function isNarrowMedia(dims) {
    if (!dims) return false;
    return dims.height >= dims.width;
  }

  function mediaLayoutTarget(gallery) {
    if (gallery.classList.contains('product-layout__media')) {
      return gallery;
    }
    return gallery.closest('.product-layout__media');
  }

  function isFixedFrame(gallery) {
    return gallery.hasAttribute('data-gallery-fixed-frame');
  }

  function setFixedFrameRatio(gallery, slide) {
    if (!isFixedFrame(gallery)) return;

    var viewport = gallery.querySelector('.product-gallery__viewport');
    if (!viewport) return;

    var dims = slide ? slideDimensions(slide) : null;
    if (!dims) return;

    viewport.style.setProperty(
      '--gallery-aspect-ratio',
      dims.width + ' / ' + dims.height
    );
  }

  function updateMediaLayout(gallery, slide) {
    var target = mediaLayoutTarget(gallery);
    if (!target) return;

    var dims = slide ? slideDimensions(slide) : null;
    target.setAttribute('data-media-span', isNarrowMedia(dims) ? 'narrow' : 'wide');
  }

  function warmSlideImage(slide) {
    if (!slide) return;

    var img = slide.querySelector('img');
    if (!img || (img.complete && img.naturalWidth)) return;

    var src = img.getAttribute('src');
    var srcset = img.getAttribute('srcset');
    if (!src && !srcset) return;

    var preloader = new Image();
    if (srcset) {
      preloader.srcset = srcset;
      preloader.sizes = img.getAttribute('sizes') || '100vw';
    }
    if (src) preloader.src = src;
  }

  function whenIdle(callback) {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(callback, { timeout: 1500 });
      return;
    }
    window.setTimeout(callback, 200);
  }

  galleries.forEach(function (gallery) {
    var slides = Array.prototype.slice.call(
      gallery.querySelectorAll('[data-product-gallery-slide]')
    );
    var counter = gallery.querySelector('[data-product-gallery-counter]');
    var prev = gallery.querySelector('[data-product-gallery-prev]');
    var next = gallery.querySelector('[data-product-gallery-next]');
    var total = slides.length;
    var index = 0;
    var resizeTimer;
    var contrastToken = { cancelled: false };

    if (!total) return;

    function warmNext(defer) {
      if (total <= 1) return;
      var nextSlide = slides[(index + 1) % total];
      if (defer) {
        whenIdle(function () {
          warmSlideImage(nextSlide);
        });
        return;
      }
      warmSlideImage(nextSlide);
    }

    function show(nextIndex, options) {
      index = ((nextIndex % total) + total) % total;
      contrastToken.cancelled = true;
      contrastToken = { cancelled: false };

      for (var i = 0; i < slides.length; i += 1) {
        var slide = slides[i];
        var active = i === index;
        slide.hidden = !active;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      }

      // Prefetch only the next slide; defer on first paint so LCP isn't contested.
      warmNext(options && options.deferWarm);

      if (counter) {
        counter.textContent = index + 1 + '/' + total;
        analyzeCounterContrast(gallery, slides[index], counter, contrastToken);
      }

      if (!isFixedFrame(gallery)) {
        updateMediaLayout(gallery, slides[index]);
      }

      if (prev) prev.disabled = total <= 1;
      if (next) next.disabled = total <= 1;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        show(index - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        show(index + 1);
      });
    }

    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        contrastToken.cancelled = true;
        contrastToken = { cancelled: false };
        analyzeCounterContrast(gallery, slides[index], counter, contrastToken);
      }, 200);
    });

    if (isFixedFrame(gallery)) {
      setFixedFrameRatio(gallery, slides[0]);
      updateMediaLayout(gallery, slides[0]);

      var firstImg = slides[0].querySelector('img');
      if (firstImg) {
        firstImg.addEventListener(
          'load',
          function () {
            setFixedFrameRatio(gallery, slides[0]);
          },
          { once: true }
        );
      }
    }

    show(0, { deferWarm: true });
  });
})();
